import React, { useState } from 'react';
import {
  Navbar,
  NavbarBrand,
  NavbarToggler,
  Collapse,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Container,
  Button
} from 'reactstrap';
import logo from '../assets/images/apex-logo.avif';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  return (
    <Navbar color="white" light expand="lg" className="shadow-sm">
      <Container className='d-flex justify-content-between align-items-center'>
        <NavbarBrand className="d-flex align-items-center">
          <a href="/">
            <img 
              src={logo}
              className="apex-logo me-1" 
              alt="logo" 
              style={{ height: '55px', width: 'auto' }}
            />
          </a>
        </NavbarBrand>

        <NavbarToggler onClick={toggle} className="custom-navbar-toggler ms-auto">
          <span></span>
          <span></span>
          <span></span>
        </NavbarToggler>

        <Collapse isOpen={isOpen} navbar>
          <Nav className="me-auto" navbar>
            <NavItem>
              <NavLink href="/about-us">About Us</NavLink>
            </NavItem>
            <UncontrolledDropdown nav inNavbar className="events-dropdown">
              <DropdownToggle nav caret className="dropdown-toggle events-toggle">
                <span>Events</span>
              </DropdownToggle>
              <DropdownMenu className="events-dropdown-menu">
                <DropdownItem className="events-dropdown-item">
                  <a className="dropdown-link" href="/upcoming-events">
                    <i className="fas fa-calendar-plus me-2"></i>
                    <span>Upcoming Events</span>
                  </a>
                </DropdownItem>
                <DropdownItem className="events-dropdown-item">
                  <a className="dropdown-link" href="/past-events">
                    <i className="fas fa-history me-2"></i>
                    <span>Past Events</span>
                  </a>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </Nav>

          {/* Buttons (Desktop) */}
          <div className="d-none d-lg-flex gap-2 ms-auto">
            <Button 
              tag="a" 
              href="/community" 
              className="btn-custom"
            >
              Join Our Community
            </Button>
            <Button 
              tag="a"
              type='button'
              href="/partner-with-us" 
              className="btn-custom-black"
            >
              Partner With Us
            </Button>
          </div>

          {/* Buttons (Mobile/Tablet inside toggle) */}
          <div className="d-lg-none mt-3 d-flex flex-column gap-2">
            <Button 
              tag="a" 
              href="/community" 
              className="btn-custom mobile-btn"
            >
              Join Our Community
            </Button>
            <Button 
              tag="a" 
              href="/partner-with-us" 
              className="btn-custom-black mobile-btn"
            >
              Partner With Us
            </Button>
          </div>
        </Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
